import {Action} from '@ngrx/store';
import {ACTION, STATUS} from '../constant';

const INIT_STATE = {
  user: null,
  status: null
};

export function PERSON_REDUCER(state = INIT_STATE, action: Action) {
  switch (action.type) {
    case ACTION.LOAD_CURRENT_USER:
      return Object.assign({}, state, {status: STATUS.IN_PROGRESS});
    case ACTION.LOAD_CURRENT_USER_COMPLETED:
      return Object.assign({}, state, {user: action.payload, status: STATUS.COMPLETED});
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/shared/reducer/person.reducer.ts